import React from "react";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { INBOX_READ_PERMISSION } from "components/dashboard/AgentInbox/permissions";
import "./TMTagItem.scss";

const TMTagItem = ({
    messagingTagId,
    messagingTagName,
    handleTagSelect,
    isActive,
}) => {
    return (
        <ComponentAccessControl baseResources={INBOX_READ_PERMISSION}>
            <div
                className={`tm__tag ${isActive ? "active" : ""}`}
                onClick={() => handleTagSelect(messagingTagId)}>
                <span>{messagingTagName}</span>
            </div>
        </ComponentAccessControl>
    );
};

export default TMTagItem;
